import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from "@angular/core";
import { appConstants } from "../../../core/config/constant";
import { SupplierV2Service } from "../service/supplier.v2.service";
interface SelectedRFQ {
  rfqId: number;
  buyerContactId?: number;
  finalQuoteStatus?:string;
  rfqName?:string;
}
@Component({
  selector: "supplier-quotes-insight",
  templateUrl: "./supplier-quotes-insight.component.html",
  styleUrls: ["./supplier-quotes-insight.component.scss"],
})
export class SupplierQuotesInsightComponent implements OnInit, OnDestroy {
  @Output() drawer_OnClose = new EventEmitter < any > ();
  @Input() selectedRFQ: SelectedRFQ = { rfqId: 0 };
  @Output() parentEmitter = new EventEmitter<{ showSidePanel: boolean }>();

  
  premiumAccount = false;
  noOfQuotes = 0;
  leadTimeDetail: any[] = [];
  priceDetail: any[] = [];
  buyerInsightDetail: any = {};
  accountType: string = "";
  isProfessionalPackage: boolean = false;
  distance: any;
  rfqName: string;
  starterGrowth: boolean;
  showTotalNoQuoteBox: boolean = false;
  showLeadTimeBox: boolean = false;
  showPricingBox: boolean = false;
  showBuyerDetailBox: boolean = false;
  
  constructor(private supplierV2Service: SupplierV2Service) {}

  ngOnInit() {
    this.accountType = AppStorageUtil.getItem("AccountType") || '';
    this.checkIsPremium();
    this.loadRfqInsights();
    this.loadBuyerDetailInsights();
    this.loadDistanceBetweenContact();
    this.rfqName = this.selectedRFQ.rfqName
    this.checkStatus()
  }

  ngOnDestroy() {
    this.closePartDrawer();
  }

  closePartDrawer() {
    this.drawer_OnClose.emit({drawerClose:true});
  }
  clickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('view-insight-button')) {
      return; // Ignore click if it's from the button
    }
    this.closePartDrawer();
  }
  private loadRfqInsights() {
    if (!this.selectedRFQ?.rfqId) return;
    this.supplierV2Service.getSupplierRfqInsightQuote(this.selectedRFQ.rfqId).subscribe({
      next: (result) => {
        if (result?.result) {
          this.noOfQuotes = result.noOfQuotes;
          this.leadTimeDetail = result.leadTimeDetail;
          this.priceDetail = result.priceDetail;
        }
      },
      error: (err) => console.error("Error fetching RFQ insights:", err),
    });
  }

  private loadBuyerDetailInsights() {
    this.supplierV2Service.getBuyerDetailInsight(this.selectedRFQ.buyerContactId).subscribe({
      next: (result) => {
        if (result) {
          this.buyerInsightDetail = result;
        }
      },
      error: (err) => console.error("Error fetching buyer insights:", err),
    });
  }
 
  private loadDistanceBetweenContact() {
    if (!this.selectedRFQ?.buyerContactId) return;
    this.supplierV2Service.getDistanceBetweenContact(this.selectedRFQ.buyerContactId).subscribe({
      next: (result) => {
        if (result.result ) {
          this.distance = Math.round(result.distance);
        } else {
          this.distance = '--'
        }
      },
      error: (err) => {
        this.distance ='--';
        
      },
    });
  }
  private checkIsPremium() {
    const premiumTypes = [appConstants.AccountType.Gold, appConstants.AccountType.Platinum];
    this.premiumAccount = premiumTypes.includes(this.accountType);
  }

  showPricingDetails(): boolean {
    const statusesToShow = ['CLOSED', 'WON', 'LOST'];
    return statusesToShow.includes(this.selectedRFQ.finalQuoteStatus);
  }

  checkStatus(){
    this. isProfessionalPackage = Boolean(AppStorageUtil.getItem("isProfessionalPackage"));
    if (this.accountType === appConstants.AccountType.Basic) {
      this.showTotalNoQuoteBox = false;
      this.showLeadTimeBox = false;
      this.showPricingBox = false;
      this.showBuyerDetailBox = false;
    } else if (!this.isProfessionalPackage && (this.accountType === appConstants.AccountType.GrowthPackage || this.accountType === appConstants.AccountType.Starter)) {
      this.showTotalNoQuoteBox = true;
      this.showLeadTimeBox = true;
      this.showPricingBox = false;
      this.showBuyerDetailBox = false;
    } else if (this.isProfessionalPackage || this.accountType === appConstants.AccountType.Gold || this.accountType ===  appConstants.AccountType.Platinum) {
      this.showTotalNoQuoteBox = true;
      this.showLeadTimeBox = true;
      this.showBuyerDetailBox = true;
      if(this.showPricingDetails()){
        this.showPricingBox = true;
      }else{
        this.showPricingBox = false;
      }
    }
  }
}
